const fr = {
  // Header
  'search': 'Rechercher...',
  'scan': 'SCAN',
  'profile': 'Profil',
  'settings': 'Paramètres',
  'logout': 'Déconnexion',
  'admin': 'ADMIN',
  'administrator': 'Administrateur',
  'admin.email': 'admin@admin.com',

  // Navbar
  'nav.dashboard': 'Tableau de bord',
  'nav.products': 'Produits',
  'nav.variants': 'Variantes',
  'nav.invoices': 'Factures',
  'nav.clients': 'Clients',

  // Login
  'login.welcome': 'BIENVENUE',
  'login.title': 'Se connecter',
  'login.subtitle': 'Accédez à votre tableau de bord',
  'login.username': "Nom d'utilisateur",
  'login.username.placeholder': "Entrez votre nom d'utilisateur",
  'login.password': 'Mot de passe',
  'login.password.forgot': 'Mot de passe oublié?',
  'login.password.placeholder': 'Entrez votre mot de passe',
  'login.remember': 'Se souvenir de moi',
  'login.connecting': 'Connexion...',
  'login.signin': 'Se connecter',
  'login.or': 'ou continuer avec',
  'login.no.account': 'Pas encore de compte?',
  'login.signup': "S'inscrire",
  'login.success': 'Connexion réussie!',
  'login.error': 'Information incorrecte!',
  'login.error.generic': 'Erreur lors de la connexion!',

  // Dashboard
  'dashboard.title': 'Tableau de bord inventaire',
  'dashboard.subtitle': 'Gérez et suivez vos produits en stock',
  'dashboard.high_stock': 'Produits en stock élevé',

  //Dates select 
  'date.today': "Aujourd'hui",
  'date.this_month': "Ce mois",
  'date.last_30_days': "Derniers 30 jours",
  'date.last_6_months': "Derniers 6 mois",
  'date.last_12_months': "Derniers 12 mois",
  'date.all_period': "Toute la période",
  'date.custom_period': "Période personnalisée",
  'date.select_period': "Sélectionnez une période",
  'date.cancel': "Annuler",
  'date.apply': "Appliquer",
  'date.months_short': ["Jan", "Fév", "Mar", "Avr", "Mai", "Jun", "Jul", "Aoû", "Sep", "Oct", "Nov", "Déc"],
  'date.months_long': ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
  'date.days_short': ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],

  // Invoices
  'invoices.title': 'Factures clients',
  'invoices.subtitle': 'Créer, enregistrer et imprimer des factures tout en mettant à jour le stock',
  'invoices.new_invoice': 'Nouvelle facture',
  'invoices.client_name': 'Nom du client',
  'invoices.client_name.placeholder': 'Entrez le nom du client',
  'invoices.invoice_code': 'Code facture',
  'invoices.remove_payment_confirm': 'Confirmer la suppression du paiement',
  'invoices.invoice_code.placeholder': 'Entrez le code de la facture',
  'invoices.logo': 'Logo',
  'invoices.product': 'Produit',
  'invoices.search_product': 'Rechercher un produit',
  'invoices.no_products_found': 'Aucun produit trouvé',
  'invoices.variant': 'Variante',
  'invoices.quantity': 'Quantité',
  'invoices.unit_price': 'Prix unitaire',
  'invoices.line_total': 'Total',
  'invoices.add_item': 'Ajouter une ligne',
  'invoices.remove_item': 'Retirer',
  'invoices.subtotal': 'Sous-total',
  'invoices.remise': 'Remise',
  'invoices.total': 'Total',
  'invoices.save': 'Enregistrer la facture',
  'invoices.saving': 'Enregistrement...',
  'invoices.saved': 'Facture enregistrée avec succès',
  'invoices.print': 'Imprimer la facture',
  'invoices.preview_title': 'Aperçu de la facture',
  'invoices.preview_description': 'Vérifiez la facture avant de l’imprimer ou de la partager.',
  'invoices.saved_invoice': 'Facture enregistrée',
  'invoices.select_product': 'Sélectionner un produit',
  'invoices.select_variant': 'Sélectionner une variante',
  'invoices.no_variant': 'Aucune variante disponible',
  'invoices.product_price': 'Prix produit par défaut',
  'invoices.items_count': 'Articles',
  'invoices.error.loading_products': 'Impossible de charger les produits',
  'invoices.error.validation': 'Veuillez corriger les erreurs du formulaire',
  'invoices.error.print': 'Impossible d’ouvrir la boîte de dialogue d’impression. Veuillez activer les popups ou réessayer.',
  'invoices.error.general': 'Une erreur est survenue lors de l’enregistrement de la facture',
  'invoices.scan_barcode': 'Scanner le code-barres',
  'invoices.scan_barcode_placeholder': 'Scannez ou saisissez le code-barres...',
  'invoices.barcode_not_found': 'Produit non trouvé pour ce code-barres',
  'invoices.item_added': 'ajouté à la facture',
  'invoices.scan_now': 'Scanner maintenant',
  'invoices.scan_title': 'Scanner de Facture',
  'invoices.scan_subtitle': 'Scannez un produit pour l\'ajouter à la facture',
  'invoices.scan_now_placeholder': 'Scannez le code-barres...',
  'invoices.scanned_items': 'Produits scannés',
  'invoices.items_waiting': 'en attente',
  'invoices.add_to_invoice': 'Ajouter',
  'invoices.add_all_to_invoice': 'Tout ajouter',
  'invoices.items_added': 'produits ajoutés à la facture',
  'invoices.stock': 'Stock',
  'invoices.scan_ready': 'Prêt à scanner',
  'invoices.scan_ready_desc': 'Utilisez votre lecteur de codes-barres pour ajouter des produits à la facture.',
  'invoices.scan_footer': 'Système de Gestion de Stock',
  'invoices.product_found': 'Produit trouvé',
  'invoices.recently_added': 'Récemment ajoutés',
  'invoices.items_added_success': 'ajoutés avec succès',
  'invoices.validation.client_name': 'Le nom du client est requis',
  'invoices.validation.invoice_code': 'Le code de la facture est requis',
  'invoices.invoice_code.draft': 'Un code provisoire sera généré',
  'invoices.validation.product': 'La sélection du produit ou le nom est requis',
  'invoices.validation.variant_required': 'Veuillez sélectionner une variante pour ce produit',
  'invoices.validation.quantity': 'La quantité doit être au moins 1',
  'invoices.client_phone': 'Téléphone du client',
  'invoices.client_phone.placeholder': 'Entrez le téléphone du client',
  'invoices.status': 'Statut',
  'invoices.status.not_yet': 'Non réglé',
  'invoices.status.regle': 'Réglé',
  'invoices.client_history.title': 'Historique client',
  'invoices.client_history.total_invoiced': 'Total facturé',
  'invoices.client_history.total_paid': 'Total payé',
  'invoices.client_history.balance': 'Solde',
  'invoices.client_history.invoices': 'Factures',
  'invoices.client_history.payments': 'Paiements',
  'invoices.client_history.no_invoices': 'Aucune facture trouvée',
  'invoices.client_history.no_payments': 'Aucun paiement trouvé',
  'invoices.client_history.payment_amount': 'Montant du paiement',
  'invoices.client_history.payment_date': 'Date de paiement',
  'invoices.client_history.payment_note': 'Note',
  'clients.title': 'Comptes clients',
  'clients.subtitle': 'Consultez les factures clients, montants impayés, paiements et ajoutez de nouveaux paiements.',
  'clients.total_clients': 'Clients totaux',
  'clients.client_list': 'Liste des clients',
  'clients.search_placeholder': 'Rechercher par nom ou téléphone...',
  'clients.name': 'Nom',
  'clients.phone': 'Téléphone',
  'clients.invoices': 'Factures',
  'clients.total_invoiced': 'Total facturé',
  'clients.balance': 'Solde',
  'clients.view_history': 'Voir l’historique',
  'clients.loading': 'Chargement des clients...',
  'clients.no_clients': 'Aucun client trouvé',
  'clients.client_history_title': 'Historique client',
  'clients.client_history_description': 'Consultez toutes les factures, paiements et soldes en attente pour le client sélectionné.',
  'clients.total_paid': 'Total payé',
  'clients.unpaid_amount': 'Montant impayé',
  'clients.invoice_list_description': 'Factures de ce client avec les paiements et soldes.',
  'clients.invoice_code': 'Code facture',
  'clients.status': 'Statut',
  'clients.total': 'Total',
  'clients.paid': 'Payé',
  'clients.select_invoice': 'Sélectionnez la facture à payer',
  'clients.add_payment': 'Ajouter un paiement',
  'clients.payment_form_title': 'Enregistrer un paiement',
  'clients.payment_form_description': 'Ajoutez un paiement pour une facture en attente.',
  'clients.payment_invoice': 'Facture',
  'clients.payment_amount': 'Montant du paiement',
  'clients.payment_note': 'Note',
  'clients.payment_note_placeholder': 'Note facultative pour ce paiement',
  'clients.payment_submit': 'Enregistrer le paiement',
  'clients.payment_saving': 'Enregistrement du paiement...',
  'clients.payment.success': 'Paiement enregistré avec succès',
  'clients.error.loading': 'Impossible de charger les clients',
  'clients.error.loading_details': 'Impossible de charger les détails du client',
  'clients.error.payment': 'Impossible d’enregistrer le paiement',
  'clients.error.payment_amount': 'Entrez un montant de paiement valide',
  'clients.payments': 'Paiements',
  'clients.no_payments': 'Aucun paiement trouvé',
  'clients.no_invoices': 'Aucune facture trouvée',
  'clients.bulk_payment_title': 'Paiement Groupé',
  'clients.bulk_payment_description': 'Distribuer un paiement sur toutes les factures impayées (de la plus ancienne à la plus récente)',
  'clients.bulk_payment_amount': 'Montant total du paiement',
  'clients.bulk_payment_submit': 'Distribuer le paiement',
  'clients.bulk_payment_saving': 'Distribution...',
  'clients.bulk_payment_success': 'Paiement distribué avec succès',
  'clients.bulk_payment_preview': 'Aperçu de la distribution',
  'clients.bulk_payment_no_unpaid': 'Aucune facture impayée à distribuer',
  'clients.transaction_history': 'Historique des transactions',
  'clients.invoice': 'Facture',
  'clients.payment': 'Paiement',
  'clients.unpaid_invoices': 'Factures impayées',
  'clients.no_transactions': 'Aucune transaction trouvée',
  'dashboard.low_stock': 'Produits en stock faible',
  'dashboard.stock_distribution': 'Répartition du stock',
  'dashboard.in_stock': 'En stock',
  'dashboard.low_stock_label': 'Stock faible',
  'dashboard.out_of_stock': 'En rupture',
  'dashboard.product_types': 'Types de produits',
  'dashboard.financial_title': 'Résumé financier',
  'dashboard.total_sales': 'Ventes totales',
  'dashboard.purchase_cost': "Coût d'achat",
  'dashboard.total_payments': 'Total encaissements',
  'dashboard.total_charges': 'Charges',
  'dashboard.profit': 'Bénéfice brut',
  'dashboard.profit_exact': 'Bénéfice net',
  'dashboard.with_variants': 'Avec variantes',
  'dashboard.without_variants': 'Sans variantes',

  // Charts
  'charts.daily_profit': 'Profit net par jour',
  'charts.invoice_count': 'Nombre de factures',
  'charts.total': 'Total',
  'charts.invoices': 'factures',
  'charts.no_data': 'Aucune donnée disponible',

  // StatsMonths
  'stats.total_products': 'Total Produits',
  'stats.low_stock_items': 'Articles stock faible',
  'stats.out_of_stock': 'En rupture',
  'stats.stock_value': 'Valeur du stock',
  'stats.monitor': 'Surveiller',

  // CardHome
  'card.no_products': 'Aucun produit',
  'card.no_products_desc': 'Ajoutez votre premier produit pour le voir ici',
  'card.no_image': 'Pas d\'image',
  'card.stock': 'Stock:',
  'card.price': 'Prix',
  'card.last_updated': 'Dernière mise à jour',

  // Products page
  'products.title': 'Produits',
  'products.subtitle': 'Gérez votre inventaire et vos niveaux de stock',
  'products.add': 'Ajouter un produit',
  'products.sync': 'Synchroniser',
  'products.syncing': 'Synchronisation...',
  'products.sync.title': 'Synchroniser les produits',
  'products.sync.confirm': 'Cela synchronisera tous les produits depuis la source externe. Continuer ?',
  'products.sync.start': 'Lancer la synchro',
  'products.all_status': 'Tous les statuts',
  'products.in_stock': 'En stock',
  'products.low_stock': 'Stock faible',
  'products.out_of_stock': 'En rupture',
  'products.search': 'Rechercher par nom ou description...',
  'products.table.product': 'Produit',
  'products.table.price': 'Prix',
  'products.table.stock': 'Stock',
  'products.table.variants': 'Variantes',
  'products.table.status': 'Statut',
  'products.table.actions': 'Actions',
  'products.pagination.previous': 'Précédent',
  'products.pagination.next': 'Suivant',
  'products.pagination.showing': 'Affichage',
  'products.pagination.of': 'sur',
  'products.pagination.to': 'à',
  'products.pagination.products': 'produits',
  'products.empty.title': 'Aucun produit trouvé',
  'products.empty.desc': 'Commencez par ajouter votre premier produit',
  'products.empty.add': 'Ajouter des produits',
  'products.delete.title': 'Supprimer le produit',
  'products.delete.warning': 'Cette action est irréversible',
  'products.delete.confirm': 'Êtes-vous sûr de vouloir supprimer',
  'products.delete.variant_warning': 'Cela supprimera également',
  'products.delete.variant_count': 'variante(s) associée(s).',
  'products.delete.cancel': 'Annuler',
  'products.delete.deleting': 'Suppression...',
  'products.delete.confirm_btn': 'Supprimer le produit',
  'products.fetch.error': 'Échec du chargement des produits',
  'products.delete.success': 'Produit supprimé avec succès',
  'products.stock.title': 'Augmenter le stock',
  'products.stock.current': 'Stock actuel',
  'products.stock.augment': 'Augmenter',
  'products.stock.success': 'Stock augmenté avec succès',
  'products.stock.error': 'Échec de l\'augmentation du stock',
  'products.stock.no_variant_qty': 'Ajoutez au moins une quantité de variante',

  // Variants page
  'variants.title': 'Variantes de produits',
  'variants.subtitle': 'Gérez toutes les variantes avec couleurs, tailles et prix',
  'variants.add': 'Ajouter une variante',
  'variants.table.name': 'Nom',
  'variants.table.value': 'Valeur',
  'variants.table.type': 'Type',
  'variants.table.actions': 'Actions',
  'variants.empty.title': 'Aucune variante trouvée',
  'variants.empty.desc': 'Commencez par ajouter votre première variante',
  'variants.empty.add': 'Ajouter une variante',
  'variants.modal.add.title': 'Ajouter une nouvelle variante',
  'variants.modal.add.desc': 'Sélectionnez le type et saisissez les détails',
  'variants.modal.select_type': 'Sélectionnez le type',
  'variants.modal.color': 'Couleur',
  'variants.modal.size': 'Taille',
  'variants.modal.color_name': 'Nom de la couleur',
  'variants.modal.hex': 'Code hexadécimal',
  'variants.modal.hex_or_picker': 'Entrez le code hex ou utilisez le sélecteur',
  'variants.modal.size_label': 'Taille',
  'variants.modal.size_desc': 'La taille sera utilisée pour le nom et la valeur',
  'variants.modal.cancel': 'Annuler',
  'variants.modal.adding': 'Ajout...',
  'variants.modal.add_variant': 'Ajouter la variante',
  'variants.modal.edit.title': 'Modifier la variante',
  'variants.modal.edit.desc': 'Mettez à jour les détails de la variante',
  'variants.modal.edit.variant_type': 'Type de variante',
  'variants.modal.edit.update': 'Mettre à jour',
  'variants.modal.edit.updating': 'Mise à jour...',
  'variants.modal.delete.title': 'Supprimer la variante',
  'variants.modal.delete.warning': 'Cette action est irréversible',
  'variants.modal.delete.confirm': 'Êtes-vous sûr de vouloir supprimer la variante',
  'variants.modal.delete.variant_name': '?',
  'variants.modal.delete.association': 'Cette variante peut être associée à des produits. La supprimer retirera ces associations.',
  'variants.modal.delete.deleting': 'Suppression...',
  'variants.modal.delete.confirm_btn': 'Supprimer la variante',
  'variants.pagination.previous': 'Précédent',
  'variants.pagination.next': 'Suivant',
  'variants.pagination.showing': 'Affichage',
  'variants.pagination.of': 'sur',
  'variants.fetch.error': 'Échec du chargement des variantes',
  'variants.add.success': 'Variante ajoutée avec succès!',
  'variants.update.success': 'Variante mise à jour avec succès!',
  'variants.delete.success': 'Variante supprimée avec succès!',
  'variants.add.error': 'Échec de l\'ajout de la variante',
  'variants.update.error': 'Échec de la mise à jour de la variante',
  'variants.delete.error': 'Échec de la suppression de la variante',
  'variants.fill.fields': 'Veuillez remplir tous les champs',

  // StockScanner
  'scanner.title': 'Scanner de Stock',
  'scanner.subtitle': 'Scannez ou saisissez un code-barres',
  'scanner.placeholder': 'Saisir le code-barres...',
  'scanner.ready': 'Prêt à scanner',
  'scanner.ready_desc': 'Utilisez votre lecteur de codes-barres ou saisissez manuellement pour décrémenter le stock.',
  'scanner.footer': 'Système de Gestion de Stock v1.3',
  'scanner.new_stock': 'Nouveau stock :',
  'scanner.last_scan': 'Dernier scan réussi',
  'scanner.variant': 'Variante :',
  'scanner.pcs': 'PCS',
  'scanner.scan_error': 'Échec du scan du code-barres',

  // AddProduct
  'product.add.title': 'Ajouter un nouveau produit',
  'product.add.desc': 'Créez un nouveau produit',
  'product.add.name': 'Nom du produit *',
  'product.add.name.placeholder': 'Entrez le nom du produit',
  'product.add.price': 'Prix *',
  'product.add.purchase_price': "Prix d'achat *",
  'product.add.quantity': 'Quantité totale *',
  'product.add.quantity.placeholder': 'Entrez la quantité',
  'product.add.image': 'Image du produit',
  'product.add.upload': 'Télécharger une image',
  'product.add.recommended': 'Recommandé: 500x500px, JPG, PNG, GIF',
  'product.add.has_variants': 'Ce produit a des variantes (couleur, taille, etc.)',
  'product.add.variants_stock': 'Chaque variante aura son propre stock',
  'product.add.no_variants_stock': 'Le produit aura une seule quantité totale',
  'product.add.variant_type': 'Type de variante',
  'product.add.colors_only': 'Couleurs uniquement',
  'product.add.sizes_only': 'Tailles uniquement',
  'product.add.colors_sizes': 'Couleurs et tailles',
  'product.add.select_color': 'Sélectionnez la couleur',
  'product.add.select_size': 'Sélectionnez la taille',
  'product.add.add_combination': 'Ajouter une combinaison',
  'product.add.add_color': 'Ajouter une couleur',
  'product.add.add_size': 'Ajouter une taille',
  'product.add.cancel': 'Annuler',
  'product.add.creating': 'Création...',
  'product.add.create': 'Créer le produit',
  'product.add.fill_fields': 'Veuillez remplir les champs obligatoires',
  'product.add.add_variant': 'Veuillez ajouter au moins une variante',
  'product.add.enter_qty': 'Veuillez entrer une quantité',
  'product.add.no_combinations': 'Aucune combinaison ajoutée',
  'product.add.no_combinations_desc': 'Ajoutez des combinaisons de couleurs et tailles pour créer différentes variantes. Chaque combinaison aura son propre stock.',
  'product.add.combination': 'Combinaison',
  'product.add.stock_qty': 'Quantité de stock *',
  'product.add.total_summary': 'Récapitulatif du stock',
  'product.add.across': 'Toutes combinaisons confondues',
  'product.add.total_units': 'Total unités',
  'product.add.select_color_error': 'Veuillez sélectionner une couleur',
  'product.add.select_size_error': 'Veuillez sélectionner une taille',
  'product.add.select_both_error': 'Veuillez sélectionner une couleur et une taille',
  'product.add.color_exists': 'Cette couleur existe déjà',
  'product.add.size_exists': 'Cette taille existe déjà',
  'product.add.combination_exists': 'Cette combinaison existe déjà',
  'product.add.success': 'Produit créé avec succès!',
  'product.add.operation_failed': 'Opération échouée',
  'product.add.load_variants_error': 'Échec du chargement des variantes',
  'product.add.enter_stock': 'Entrez le stock',

  // EditProduct
  'product.edit.title': 'Modifier le produit',
  'product.edit.desc': 'Mettez à jour les détails du produit',
  'product.edit.name': 'Nom du produit *',
  'product.edit.name.placeholder': 'Entrez le nom du produit',
  'product.edit.price': 'Prix *',
  'product.edit.purchase_price': "Prix d'achat *",
  'product.edit.quantity': 'Quantité totale *',
  'product.edit.quantity.placeholder': 'Entrez la quantité',
  'product.edit.image': 'Image du produit',
  'product.edit.upload': 'Télécharger une image',
  'product.edit.recommended': 'Recommandé: 500x500px, JPG, PNG, GIF',
  'product.edit.has_variants': 'Ce produit a des variantes (couleur, taille, etc.)',
  'product.edit.variants_stock': 'Chaque variante aura son propre stock',
  'product.edit.no_variants_stock': 'Le produit aura une seule quantité totale',
  'product.edit.variant_type': 'Type de variante',
  'product.edit.colors_only': 'Couleurs uniquement',
  'product.edit.sizes_only': 'Tailles uniquement',
  'product.edit.colors_sizes': 'Couleurs et tailles',
  'product.edit.select_color': 'Sélectionnez la couleur',
  'product.edit.select_size': 'Sélectionnez la taille',
  'product.edit.add_combination': 'Ajouter une combinaison',
  'product.edit.add_color': 'Ajouter une couleur',
  'product.edit.add_size': 'Ajouter une taille',
  'product.edit.cancel': 'Annuler',
  'product.edit.updating': 'Mise à jour...',
  'product.edit.update': 'Mettre à jour',
  'product.edit.success': 'Produit mis à jour avec succès!',

  // TrTableProducts
  'table.no_variants': 'Aucune variante',
  'table.has_variants': 'A des variantes',
  'table.no_image': 'Pas d\'image',
  'table.in_stock': 'en stock',
  'table.cost': 'Coût:',
  'table.selling_price': 'Prix de vente:',
  'table.cost_price': "Prix d'achat:",
  'table.margin': 'Marge:',
  'table.pricing': 'Prix',
  'table.color_size': 'Couleur / Taille',
  'table.color': 'Couleur',
  'table.size': 'Taille',
  'table.stock': 'Stock',
  'table.no_data': 'Aucune donnée de variante',
  'table.close': 'Fermer',
  'table.augment_stock': 'Augmenter le stock',
  'table.view_variants': 'Voir les variantes',
  'table.print_stickers': 'Imprimer les stickers QR',
  'table.edit_product': 'Modifier le produit',
  'table.delete_product': 'Supprimer le produit',
  'table.total_stock': 'Stock total:',
  'table.units': 'unités',
  'table.pcs': 'PCS',
  'table.more': 'plus',
  'table.variant': 'variante',
  'table.variants': 'variantes',

  // StickersPrint
  'print.title': 'Imprimer des stickers',
  'print.copies': 'Copies:',
  'print.print': 'Imprimer',
  'print.pages': 'pages',
  'print.stickers': 'stickers',
  'print.missing_barcode': 'Code-barres manquant',
  'print.stock': 'Stock:',
  'print.colors': 'couleurs',
  'print.sizes': 'tailles',
  'print.variants': 'variantes',
  'print.page': 'Page',

  // Common
  'common.colors_only_desc': 'Ajoutez différentes couleurs du même produit (ex: Rouge, Bleu, Noir)',
  'common.sizes_only_desc': 'Ajoutez différentes tailles du même produit (ex: S, M, L, XL)',
  'common.both_desc': 'Ajoutez des combinaisons couleur et taille (ex: Rouge/S, Bleu/M)',
  'common.enter_stock': 'Entrez le stock',
  'common.loading': 'Chargement...',
  'common.error': 'Erreur',
  'common.success': 'Succès',

  // Invoices - Additional
  'invoices.all_invoices': 'Toutes les factures',
  'invoices.edit': 'Modifier',
  'invoices.update_success': 'Facture mise à jour avec succès',
  'invoices.save_edit': 'Enregistrer les modifications',
  'invoices.price_paye': 'Montant payé',
  'invoices.balance': 'Solde',
  'invoices.add_payment': 'Ajouter un paiement',
  'invoices.view': 'Voir',
  'invoices.history': 'Historique',
  'invoices.loading': 'Chargement des factures...',
  'invoices.no_invoices': 'Aucune facture trouvée',
  'invoices.add_payment_form': 'Enregistrer le paiement',
  'invoices.payment_amount': 'Montant du paiement',
  'invoices.payment_note': 'Remarque',
  'invoices.payment_note_placeholder': 'Remarque facultative pour ce paiement',
  'invoices.cancel': 'Annuler',
  'invoices.payment_submit': 'Enregistrer',
  'invoices.payment_saving': 'Enregistrement...',
  'invoices.payment_history': 'Historique des paiements',
  'invoices.no_payments': 'Aucun paiement enregistré',
  'invoices.error.payment_amount': 'Veuillez entrer un montant de paiement valide',
  'invoices.error.payment': 'Impossible d\'enregistrer le paiement',
  'invoices.payment.success': 'Paiement enregistré avec succès',
  'invoices.delete': 'Supprimer',
  'invoices.delete_confirm': 'Êtes-vous sûr de vouloir supprimer cette facture ?',
  'invoices.delete_success': 'Facture supprimée avec succès',
  'invoices.deleting': 'Suppression...',
  'invoices.remove_payment': 'Retirer',
  'invoices.payment_removed': 'Paiement retiré avec succès',
  'invoices.yes_delete': 'Oui, supprimer',
  'invoices.yes_remove': 'Oui, retirer',

  'nav.charges': 'Charges',
  'nav.activity_log': "Journal d'activité",

  'charges.title': 'Charges',
  'charges.subtitle': 'Suivez toutes les dépenses et paiements',
  'charges.add': 'Ajouter une charge',
  'charges.edit': 'Modifier la charge',
  'charges.title_label': 'Titre',
  'charges.amount': 'Montant',
  'charges.date': 'Date',
  'charges.notes': 'Notes',
  'charges.actions': 'Actions',
  'charges.loading': 'Chargement des charges...',
  'charges.no_charges': 'Aucune charge trouvée',
  'charges.title_placeholder': 'Entrez le titre de la charge',
  'charges.amount_placeholder': '0.00',
  'charges.notes_placeholder': 'Notes facultatives',
  'charges.add_success': 'Charge ajoutée avec succès',
  'charges.update_success': 'Charge modifiée avec succès',
  'charges.delete_success': 'Charge supprimée avec succès',
  'charges.error.loading': 'Impossible de charger les charges',
  'charges.error.saving': 'Impossible d\'enregistrer la charge',
  'charges.error.deleting': 'Impossible de supprimer la charge',
  'charges.delete_confirm': 'Êtes-vous sûr de vouloir supprimer cette charge ?',
  'charges.total': 'Total des charges',
  'charges.from': 'Du',
  'charges.to': 'Au',
  'charges.filter_btn': 'Filtrer',
  'charges.clear': 'Effacer',
  'charges.saving': 'Enregistrement...',

  'activity_log.title': "Journal d'activité",
  'activity_log.subtitle': 'Suivez toutes les actions effectuées dans l\'application',
  'activity_log.loading': 'Chargement du journal...',
  'activity_log.no_logs': 'Aucune activité enregistrée',
  'activity_log.action': 'Action',
  'activity_log.description': 'Description',
  'activity_log.user': 'Utilisateur',
  'activity_log.date': 'Date',
  'activity_log.details': 'Détails',
  'activity_log.actions.created': 'Création',
  'activity_log.actions.updated': 'Modification',
  'activity_log.actions.deleted': 'Suppression',
  'activity_log.actions.payment': 'Paiement',
  'activity_log.actions.payment_deleted': 'Paiement Retiré',
  'activity_log.actions.stock_augmented': 'Stock Augmenté',

  // Nav
  'nav.users': 'Utilisateurs',
  'nav.roles': 'Rôles',

  // Users
  'users.title': 'Gestion des utilisateurs',
  'users.subtitle': 'Gérez les utilisateurs du système et leurs rôles',
  'users.add': 'Ajouter un utilisateur',
  'users.edit': 'Modifier l\'utilisateur',
  'users.name': 'Nom',
  'users.email': 'Email',
  'users.password': 'Mot de passe',
  'users.password_optional': 'Mot de passe (laisser vide pour conserver)',
  'users.password_confirmation': 'Confirmer le mot de passe',
  'users.role': 'Rôle',
  'users.actions': 'Actions',
  'users.select_role': 'Sélectionner un rôle',
  'users.no_users': 'Aucun utilisateur trouvé',
  'users.name_placeholder': 'Entrez le nom',
  'users.email_placeholder': 'Entrez l\'email',
  'users.password_placeholder': 'Entrez le mot de passe',
  'users.add_success': 'Utilisateur créé avec succès',
  'users.update_success': 'Utilisateur mis à jour avec succès',
  'users.delete_success': 'Utilisateur supprimé avec succès',
  'users.error.saving': 'Impossible d\'enregistrer l\'utilisateur',
  'users.error.deleting': 'Impossible de supprimer l\'utilisateur',
  'users.delete_confirm': 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
  'users.delete_confirm_btn': 'Supprimer l\'utilisateur',
  'users.cancel': 'Annuler',
  'users.saving': 'Enregistrement...',
  'users.deleting': 'Suppression...',

  // Permission Groups
  'permission_group.dashboard': 'Tableau de bord',
  'permission_group.products': 'Produits',
  'permission_group.variants': 'Variantes',
  'permission_group.invoices': 'Factures',
  'permission_group.clients': 'Clients',
  'permission_group.charges': 'Charges',
  'permission_group.activity_logs': "Journal d'activité",
  'permission_group.users': 'Utilisateurs',
  'permission_group.roles': 'Rôles',
  'permission_group.scanner': 'Scanner',

  // Permissions
  'permissions.dashboard.view': 'Voir le tableau de bord',
  'permissions.products.view': 'Voir les produits',
  'permissions.products.create': 'Créer des produits',
  'permissions.products.edit': 'Modifier des produits',
  'permissions.products.delete': 'Supprimer des produits',
  'permissions.products.stock': 'Gérer le stock',
  'permissions.variants.view': 'Voir les variantes',
  'permissions.variants.create': 'Créer des variantes',
  'permissions.variants.edit': 'Modifier des variantes',
  'permissions.variants.delete': 'Supprimer des variantes',
  'permissions.invoices.view': 'Voir les factures',
  'permissions.invoices.create': 'Créer des factures',
  'permissions.invoices.pay': 'Enregistrer des paiements',
  'permissions.invoices.edit': 'Modifier les factures',
  'permissions.invoices.delete': 'Supprimer des factures',
  'permissions.clients.view': 'Voir les clients',
  'permissions.charges.view': 'Voir les charges',
  'permissions.charges.create': 'Créer des charges',
  'permissions.charges.edit': 'Modifier des charges',
  'permissions.charges.delete': 'Supprimer des charges',
  'permissions.activity_logs.view': "Voir le journal d'activité",
  'permissions.users.manage': 'Gérer les utilisateurs',
  'permissions.roles.manage': 'Gérer les rôles',
  'permissions.scan.stock': 'Scanner le stock',

  // Roles
  'roles.title': 'Gestion des rôles',
  'roles.subtitle': 'Gérez les rôles et les permissions',
  'roles.add': 'Ajouter un rôle',
  'roles.edit': 'Modifier le rôle',
  'roles.name': 'Nom du rôle',
  'roles.name_placeholder': 'Entrez le nom du rôle',
  'roles.permissions': 'Permissions',
  'roles.permissions_count': 'Permissions',
  'roles.users_count': 'Utilisateurs',
  'roles.actions': 'Actions',
  'roles.no_roles': 'Aucun rôle trouvé',
  'roles.add_success': 'Rôle créé avec succès',
  'roles.update_success': 'Rôle mis à jour avec succès',
  'roles.delete_success': 'Rôle supprimé avec succès',
  'roles.error.saving': 'Impossible d\'enregistrer le rôle',
  'roles.error.deleting': 'Impossible de supprimer le rôle',
  'roles.delete_confirm': 'Êtes-vous sûr de vouloir supprimer ce rôle ?',
  'roles.delete_confirm_btn': 'Supprimer le rôle',
  'roles.cancel': 'Annuler',
  'roles.saving': 'Enregistrement...',
  'roles.deleting': 'Suppression...',
}

export default fr
